import { fetcher, ListResponse } from '@tlx/astro-shared';
import useSWR from 'swr';
import { dateUtil } from '@Util/date.ts';
import { getLocale } from '@tlx/intl';
import { APIUrls } from '@Util/urls.ts';

export type AccountingPeriod = {
    id: number;
    number: number;
    checkWageLogEmployeeName: string | null;
    checkWageLogEmployeePictureId: number | null;
    checkWageLogTime: string | null;
};

export function useFetchAccountingPeriods(
    dateFrom: Date | undefined | null,
    dateTo: Date | undefined | null,
    onSuccess?: (data: Array<AccountingPeriod>) => void,
) {
    const url = getUrl(dateFrom, dateTo);

    const { data, mutate, isLoading } = useSWR<ListResponse<AccountingPeriod>>(url, fetcher, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        onSuccess: (responseData) => onSuccess?.(responseData.values),
    });

    return { accountingPeriods: data?.values, mutate, isLoading };
}

function getUrl(dateFrom: Date | undefined | null, dateTo: Date | undefined | null) {
    if (dateFrom === null || dateTo === null || dateFrom === undefined || dateTo === undefined) {
        return null;
    }

    const url = new URL(APIUrls.ACCOUNTING_PERIODS, window.location.origin);

    url.searchParams.set('fields', 'id,number,checkWageLogEmployeeName,checkWageLogEmployeePictureId,checkWageLogTime');
    url.searchParams.set('startFrom', dateUtil.formatDate(dateFrom, getLocale()));
    url.searchParams.set('startTo', dateUtil.formatDate(dateTo, getLocale()));

    return url.href;
}
